import { createCreateActionType } from "@multiweb/reactUtils";

/**
 * Jméno modulu `controls`. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "controls";

/**
 * Pomocná funkce pro vytvoření typu akce.
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

export const INIT_CONTROLS_VALUE = createActionType("INIT_CONTROLS_VALUE");
export const SET_VALIDATION_DESCRIPTIONS = createActionType("SET_VALIDATION_DESCRIPTIONS");
export const CONTROLS_VALUE_CHANGED = createActionType("CONTROLS_VALUE_CHANGED");
export const CLEAR_CONTROLS_VALUE = createActionType("CLEAR_CONTROLS_VALUE");
export const VALIDATE = createActionType("VALIDATE");
export const CLEAR_VALIDATION_ERRORS = createActionType("CLEAR_VALIDATION_ERRORS");
